import React, { useEffect, useState } from "react";
import { Image, Row, Col } from "antd";
import "@pages/LandingPage/index.scss";

import SmsImg from "@assets/images/ldp/sms.png";
import DeliveryImg from "@assets/images/ldp/delivery.png";
import HomeHeader from "@components/HomeHeader";

const LandingPage = () => {
  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 768;
  const isWebOneColumn = width <= 1200;

  return (
    <div>
      <HomeHeader tabActive={3} />
      {isMobile
        ? renderMobileHtml()
        : isWebOneColumn
        ? renderWebOneColumnHtml()
        : renderWebHtml()}
    </div>
  );
};

const renderWebHtml = () => {
  return (
    <div className="box">
      <div className="box-text">
        <div className="box-title">¿Cómo recibo mi premio si gané?</div>
      </div>
      <Row className="box-item">
        <Col xl={12} md={24}>
          <div className="item-wrapper">
            <div className="item-desc">
              1. El ganador recibirá un SMS donde se le indica que es el ganador
              de la subasta y se le informa que el 123 (Centro de Atencion al
              Cliente de Bitel) se estará comunicando.
            </div>
          </div>
        </Col>
        <Col xl={12} md={24}>
          <div className="item-wrapper">
            <div className="item-desc">
              2. Una vez que el Centro de Atención al Cliente de Bitel confirme
              los datos del ganador, coordinará la entrega del premio en la
              locación elegida por Bitel.
            </div>
          </div>
        </Col>
        <Col xl={12} md={24}>
          <div className="item-wrapper">
            <div className="guide-item">
              <div className="item-header">
                <span>Paso 1</span>
              </div>
              <div className="item-content">
                <Image preview={false} src={SmsImg} />
              </div>
            </div>
          </div>
        </Col>
        <Col xl={12} md={24}>
          <div className="item-wrapper">
            <div className="guide-item">
              <div className="item-header">
                <span>Paso 2</span>
              </div>
              <div className="item-content">
                <Image preview={false} src={DeliveryImg} />
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

const renderWebOneColumnHtml = () => {
  return (
    <div className="box">
      <div className="box-text">
        <div className="box-title">¿Cómo recibo mi premio si gané?</div>
      </div>
      <Row className="box-item">
        <Col xl={12} md={24}>
          <div className="item-wrapper">
            <div className="item-desc">
              1. El ganador recibirá un SMS donde se le indica que es el ganador
              de la subasta y se le informa que el 123 (Centro de Atencion al
              Cliente de Bitel) se estará comunicando.
            </div>
          </div>
        </Col>
        <Col xl={12} md={24}>
          <div className="item-wrapper">
            <div className="guide-item">
              <div className="item-header">
                <span>Paso 1</span>
              </div>
              <div className="item-content">
                <Image preview={false} src={SmsImg} />
              </div>
            </div>
          </div>
        </Col>
        <Col xl={12} md={24}>
          <div className="item-wrapper">
            <div className="item-desc">
              2. Una vez que el Centro de Atención al Cliente de Bitel confirme
              los datos del ganador, coordinará la entrega del premio en la
              locación elegida por Bitel.
            </div>
          </div>
        </Col>
        <Col xl={12} md={24}>
          <div className="item-wrapper">
            <div className="guide-item">
              <div className="item-header">
                <span>Paso 2</span>
              </div>
              <div className="item-content">
                <Image preview={false} src={DeliveryImg} />
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

const renderMobileHtml = () => {
  return (
    <div className="box">
      <div className="box-text">
        <div className="box-title">¿Cómo recibo mi premio si gané?</div>
      </div>
      <Row className="box-item">
        <Col md={12} sm={24}>
          <div className="item-wrapper">
            <div className="item-desc">
              1. El ganador recibirá un SMS donde se le indica que es el ganador
              de la subasta y se le informa que el 123 (Centro de Atencion al
              Cliente de Bitel) se estará comunicando.
            </div>
            <div className="guide-item">
              <div className="item-header">
                <span>Paso 1</span>
              </div>
              <div className="item-content">
                <Image preview={false} src={SmsImg} />
              </div>
            </div>
          </div>
        </Col>
        <Col md={12} sm={24}>
          <div className="item-wrapper">
            <div className="item-desc">
              2. Una vez que el Centro de Atención al Cliente de Bitel confirme
              los datos del ganador, coordinará la entrega del premio en la
              locación elegida por Bitel.
            </div>
            <div className="guide-item">
              <div className="item-header">
                <span>Paso 2</span>
              </div>
              <div className="item-content">
                <Image preview={false} src={DeliveryImg} />
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default LandingPage;
